import { useState } from "react";
import api from "../api/PosApi";
import { Card, Container, Row, Col } from "react-bootstrap";

export default function Productos() {
  const [term, setTerm] = useState("");
  const [productos, setProductos] = useState([]);
  const [nuevo, setNuevo] = useState({
    nombre: "",
    precio: 0,
    tipoItem: 2, // servicio por defecto
    unidadMedida: "59",
    tributoCodigo: "20"
  });
  const [mensaje, setMensaje] = useState("");

  const buscar = async () => {
    try {
      const res = await api.get(`/pos/productos?term=${term}`);
      setProductos(res.data);
    } catch {
      setMensaje("❌ Error al buscar productos");
    }
  };

  const crearProducto = async () => {
    try {
      if (!nuevo.nombre || nuevo.precio === 0) {
        setMensaje('Debes colocar detalles o precios validos.');
        return;
      }
      const res = await api.post("/pos/productos", nuevo);
      setMensaje(`✅ Producto creado: ${res.data.nombre}`);
      setNuevo({
        nombre: "",
        precio: 0,
        tipoItem: 2,
        unidadMedida: "59",
        tributoCodigo: "20"
      });
    } catch {
      setMensaje("❌ Error al crear producto");
    }
  };

  return (
    <Container>
      <Row>
        <Col>
          <Card className="card-black mb-3">
            <Card.Header>
              <h3>Gestión de Productos / Servicios</h3>
            </Card.Header>
            <Card.Body>
              <Row className="mb-3">
                <p>Buscar | Filtrar</p>
                <Col xl={10} className="form-group">
                  <input
                    className="form-control"
                    id="nombre"
                    placeholder="Nombre"
                    value={term}
                    onChange={(e) => setTerm(e.target.value)}
                  />
                </Col>
                <Col xl={2}>
                  <button className="btn btn-primary w-100" onClick={buscar}>Buscar</button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <ul>
                    {productos.map((p: any) => (
                      <li key={p.id}>
                        {p.nombre} (${p.precio})
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card className="card-black">
            <Card.Header>
              <h3>Agregar un nuevo producto o servicio</h3>
            </Card.Header>
            <Card.Body>
              <Row className="mb-3">
                <Col className="form-group">
                  <label htmlFor="nombre">Detalle</label>
                  <textarea
                    id="nombre"
                    className="form-control"
                    placeholder="Nombre"
                    aria-multiline
                    value={nuevo.nombre}
                    onChange={(e) => setNuevo({ ...nuevo, nombre: e.target.value })}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="form-group">
                  <label htmlFor="price">Precio</label>
                  <input
                    id="price"
                    className="form-control"
                    placeholder="Precio Unitario"
                    type="number"
                    value={nuevo.precio}
                    onChange={(e) =>
                      setNuevo({ ...nuevo, precio: parseFloat(e.target.value) })
                    }
                  />
                </Col>
                <Col className="form-group">
                  <label htmlFor="Type">Tipo</label>
                  <select
                    id="Type"
                    className="form-control"
                    value={nuevo.tipoItem}
                    onChange={(e) =>
                      setNuevo({ ...nuevo, tipoItem: parseInt(e.target.value) })
                    }
                  >
                    <option value={1}>Bien</option>
                    <option value={2}>Servicio</option>
                  </select>
                </Col>
                <Col>
                  <button onClick={crearProducto} className="btn btn-success w-100 h-100">Guardar Producto</button>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className="mt-1 text-warning">
                    {mensaje && mensaje}
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>


  );
}
